import { ComponentType } from 'react'
import { Blog } from './blog'
import { Footer } from './footer'
import { Header } from './header'
import { Properties } from './properties'

interface Props {
  suptitle: string
  title: string
  properties: any[]
  total: number
  page: number
  limit: number
  loading: boolean
}

export const Listing: ComponentType<Props> = ({ suptitle, title, properties, total, page, limit, loading }) => (
  <>
    <Header {...{ suptitle, title }} />
    <Properties {...{ properties, total, limit, page, loading }} />
    <Blog />
    <Footer />
  </>
)
